export default __webpack_public_path__ + "static/G6_ND_25_2021RGB2Spiral-663f15c457754bcc7744250a98453874.jpg";